module.exports = __webpack_public_path__ + "static/render_night_2K_sig-12741a2b8eeebff1f2b656c4dcd4a280.jpg";